import {lazy} from 'react';

export const CountrySelectionLazy = lazy(() => import(/* webpackChunkName: "countrySelection" */ '.'));
